export default __webpack_public_path__ + "static/media/g2022-8.f679d664.jpeg";